<template>
  <a-modal
    v-model:visible="showAddFeature"
    centered
    closable
    title="Add Feature"
    :footer="null"
    destroy-on-close
  >
    <add-feature @toggleModal="(value) => (showAddFeature = value)" />
  </a-modal>

  <a-row class="p-4" :gutter="[16, 16]">
    <a-col :xs="24" :md="18">
      <a-typography-title :level="4" class="mb-1">
        Feature Control
      </a-typography-title>
      <a-typography-paragraph type="secondary" class="mb-0">
        Features are optional portal capabilities. Enable a feature for an
        organization to turn it on for that customer. Disabling a feature turns
        it off for every organization at once.
      </a-typography-paragraph>
    </a-col>
    <a-col :xs="24" :md="6" class="d-flex justify-content-end align-items-start">
      <a-button
        class="d-flex align-items-center"
        type="primary"
        @click="showAddFeature = true"
      >
        <template #icon><i class="bi bi-plus mr-1 mb-1"></i></template>
        Add Feature
      </a-button>
    </a-col>

    <a-col span="24">
      <a-alert
        v-if="loadError"
        type="error"
        show-icon
        class="mb-3"
        :message="loadError"
      >
        <template #description>
          <a-button size="small" @click="load">Retry</a-button>
        </template>
      </a-alert>

      <a-tabs v-model:activeKey="activeTab">
        <a-tab-pane key="organization" tab="By organization">
          <by-organization />
        </a-tab-pane>
        <a-tab-pane key="feature" tab="By feature">
          <by-feature />
        </a-tab-pane>
      </a-tabs>
    </a-col>
  </a-row>
</template>
<script>
import { mapActions } from 'vuex';
import AddFeature from './AddFeature.vue';
import ByFeature from './ByFeature.vue';
import ByOrganization from './ByOrganization.vue';
import { apiErrorMessage } from './featureControlMixin';

export default {
  components: {
    AddFeature,
    ByFeature,
    ByOrganization,
  },
  data() {
    return {
      showAddFeature: false,
      activeTab: 'organization',
      loadError: '',
    };
  },
  mounted() {
    this.getOrganizations();
    this.load();
  },
  methods: {
    ...mapActions(['getOrganizations', 'fetchAdminFeatureControl']),
    async load() {
      const [error] = await this.fetchAdminFeatureControl();
      this.loadError = error
        ? apiErrorMessage(error, 'Could not load feature data.')
        : '';
    },
  },
};
</script>
